import { render, staticRenderFns } from "./newsCen.vue?vue&type=template&id=26042266&scoped=true&"
import script from "./newsCen.vue?vue&type=script&lang=js&"
export * from "./newsCen.vue?vue&type=script&lang=js&"
import style1 from "./newsCen.vue?vue&type=style&index=1&id=26042266&scoped=true&lang=scss&"
import style2 from "./newsCen.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26042266",
  null
  
)

export default component.exports